import * as React from 'react';

import cx from 'classnames';

interface Props {
  isCorrect: boolean;
}

export const ChoiceLabel: React.FC<Props> = ({
  isCorrect,
}: React.PropsWithChildren<Props>) => {
  const iconClass = cx(
    'relative flex flex-none items-center justify-center w-9 h-9 rounded-round font-display font-700 text-base',
    'choice-label',
    {
      'bg-grey-300 text-blue-900': !isCorrect,
      'bg-green-500 text-white': isCorrect,
    }
  );

  return (
    <div className={iconClass}>
      <span></span>
    </div>
  );
};

export default ChoiceLabel;
